<p-table #dt [columns]="cols" [value]="dados" [rowHover]="true" [loading]="loading" [scrollable]="true"
  scrollHeight="50vh" [autoLayout]="true"
  styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines p-datatable-responsive-demo p-shadow-3"
  sortMode="multiple" [globalFilterFields]="['codDealer']" paginatorDropdownAppendTo="body">
  <ng-template pTemplate="colgroup" let-columns>
    <colgroup *ngFor="let col of columns">
      <col [style]="col.width">
    </colgroup>
  </ng-template>

  <ng-template #message pTemplate="emptymessage" let-columns>
    <tr *ngIf="dados?.length != 0">
      <td id="message" [attr.colspan]="columns.length" class="text-center bg-no-records p-shadow-3"
        style="padding: 20px;">
        <p class="full-width main-div text-muted">Nenhum Registro Encontrado</p>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="2"
        class="frozenColumn">
        Todos os Tipos
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="4">
        Abr / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="4">
        Mai / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="4">
        Jun / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="4">
        Q1 / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="4">
        Jul / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="4">
        Ago / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="4">
        Set / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="4">
        Q2 / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="4">
        Out / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="4">
        Nov / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="4">
        Dez / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="4">
        Q3 / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="4">
        Jan / {{totaisHistorico.filtroAno + 1}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="4">
        Fev / {{totaisHistorico.filtroAno + 1}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="4">
        Mar / {{totaisHistorico.filtroAno + 1}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="4">
        Q4 / {{totaisHistorico.filtroAno + 1}}
      </th>
    </tr>
    <tr>
      <ng-container *ngFor="let col of columns">
        <th [pSortableColumn]="col.field" style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);"
          [ngStyle]="{'width': col.width}"
          [class.frozenColumnDealer]="col.field == 'b_codDealer'" 
          [class.frozenColumnNome]="col.field == 'c_nomeDealer'"
          [style.position]="(col.field == 'b_codDealer' || col.field == 'c_nomeDealer') ? 'sticky' : 'relative'"
          [style.z-index]="(col.field == 'b_codDealer' || col.field == 'c_nomeDealer') ? '100' : 'auto'">
          {{col.header}}
          <p-sortIcon [field]="col.field" class="p-sortable-colum"
            *ngIf="col.field !== 'selecionar' && col.field !== 'edit'">
          </p-sortIcon>
        </th>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-dados let-columns="columns">
    <tr>
      <td *ngFor="let col of columns" 
          [class.frozenColumnInfoDealer]="col.field == 'b_codDealer'"
          [class.frozenColumnInfoNome]="col.field == 'c_nomeDealer'"
          [style.position]="(col.field == 'b_codDealer' || col.field == 'c_nomeDealer') ? 'sticky' : 'relative'"
          [style.z-index]="(col.field == 'b_codDealer' || col.field == 'c_nomeDealer') ? '99' : 'auto'">
        <div *ngIf="col.field != 'visivel'">
          <ng-container *ngIf="col.type; else checkFieldName">
            {{ col.type.transform(dados[col.field], col.arg1) }}
          </ng-container>
          <ng-template #checkFieldName>
            <ng-container *ngIf="col.field.includes('Percent'); else checkMonetary">
              {{ dados[col.field] | number:'1.2-2':'pt-BR' }}%
            </ng-container>
            <ng-template #checkMonetary>
              <ng-container *ngIf="col.field.includes('Realizado') || col.field.includes('Objetivo') || col.field.includes('Gap'); else normalValue">
                {{ dados[col.field] | number:'1.2-2':'pt-BR' }}
              </ng-container>
              <ng-template #normalValue>
                {{ dados[col.field] }}
              </ng-template>
            </ng-template>
          </ng-template>
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="footer" let-dados let-columns="columns">
    <tr>
      <td class="text-center frozenColumn" style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);"
        colspan="2">
        Brasil
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalAbrRealizado | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalAbrObjetivo | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalAbrGap | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalAbrPercent | number:'1.2-2':'pt-BR'}}%
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalMaiRealizado | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalMaiObjetivo | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalMaiGap | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalMaiPercent | number:'1.2-2':'pt-BR'}}%
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalJunRealizado | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalJunObjetivo | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalJunGap | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalJunPercent | number:'1.2-2':'pt-BR'}}%
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalQ1Realizado | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalQ1Objetivo | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalQ1Gap | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalQ1Percent | number:'1.2-2':'pt-BR'}}%
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalJulRealizado | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalJulObjetivo | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalJulGap | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalJulPercent | number:'1.2-2':'pt-BR'}}%
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalAgoRealizado | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalAgoObjetivo | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalAgoGap | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalAgoPercent | number:'1.2-2':'pt-BR'}}%
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalSetRealizado | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalSetObjetivo | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalSetGap | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalSetPercent | number:'1.2-2':'pt-BR'}}%
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalQ2Realizado | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalQ2Objetivo | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalQ2Gap | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalQ2Percent | number:'1.2-2':'pt-BR'}}%
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalOutRealizado | number:'1.2-2':'pt-BR'   }}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalOutObjetivo | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalOutGap | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalOutPercent | number:'1.2-2':'pt-BR'}}%
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalNovRealizado | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalNovObjetivo | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalNovGap | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalNovPercent | number:'1.2-2':'pt-BR'}}%
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalDezRealizado | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalDezObjetivo | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalDezGap | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalDezPercent | number:'1.2-2':'pt-BR'}}%
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalQ3Realizado | number:'1.2-2':'pt-BR' }}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalQ3Objetivo | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalQ3Gap | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalQ3Percent | number:'1.2-2':'pt-BR'}}%
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalJanRealizado | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalJanObjetivo | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalJanGap | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalJanPercent | number:'1.2-2':'pt-BR'}}%
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalFevRealizado | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalFevObjetivo | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalFevGap | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalFevPercent | number:'1.2-2':'pt-BR'}}%
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalMarRealizado | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalMarObjetivo | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalMarGap | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalMarPercent | number:'1.2-2':'pt-BR'}}%
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalQ4Realizado | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalQ4Objetivo | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalQ4Gap | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
         {{totaisHistorico.totalQ4Percent | number:'1.2-2':'pt-BR'}}%
      </td>
    </tr>
  </ng-template>
</p-table>

<div class="card" *ngIf="dados?.length === 0">
  <div class="card-body bg-no-records p-shadow-3">
    <p class="full-width main-div text-muted">Nenhum Registro Encontrado</p>
  </div>
</div>
